// extracted by mini-css-extract-plugin
export default {"container":"style_container__TSQvK","btn":"style_btn__mkK2d","openedContainer":"style_openedContainer__db+KO"};